import { koComponent } from '../../ko-utils';

class EditorSettings {
    constructor(params) {
        this.settings = ko.unwrap(params.settings);
        this.saveCallback = params.saveCallback;

        this.cancel = params.cancelCallback ? params.cancelCallback : () => { };
    }
}

export default koComponent('editor-settings', EditorSettings);